package com.wintermar.inspection.feature.data.repository.answer

import com.wintermar.inspection.AppDatabase
import com.wintermar.inspection.core.domain.Result
import com.wintermar.inspection.feature.data.local.db.SqliteCompat
import com.wintermar.inspection.feature.data.remote.mapper.answer.toAnswerSelectionModel
import com.wintermar.inspection.feature.domain.model.answer.AnswerSelectionModel
import com.wintermar.inspection.feature.domain.repository.answer.AnswerSelectionRepository
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

class AnswerSelectionRepositoryImpl(
    private val appDatabase: AppDatabase
) : AnswerSelectionRepository {
    override suspend fun insertAnswerSelection(answerSelection: AnswerSelectionModel): Result<Unit> {
        return withContext(Dispatchers.Default) {
            try {
                appDatabase.transaction {
                    val executableQuery = SqliteCompat.selectInsertImplementation(
                        appDatabase = appDatabase,
                        upsert = appDatabase.answerSelectionTableQueries::insertAnswerSelection,
                        replace = appDatabase.answerSelectionTableQueries::insertReplaceAnswerSelection
                    )
                    executableQuery(
                        answerSelection.id,
                        answerSelection.answerId,
                        answerSelection.answerSelectionId,
                        answerSelection.answerSelectionValue
                    )
                }
                Result.Success(Unit)
            } catch (e: Exception) {
                Result.Error(e)
            }
        }
    }

    override suspend fun deleteAnswerSelectionByAnswerId(answerId: String): Result<Unit> {
        return withContext(Dispatchers.Default) {
            try {
                appDatabase.transaction {
                    appDatabase.answerSelectionTableQueries.deleteAnswerSelectionByAnswerId(answerId)
                }
                Result.Success(Unit)
            } catch (e: Exception) {
                Result.Error(e)
            }
        }
    }

    override suspend fun deleteAnswerSelectionByAnswerIds(answerIds: List<String>): Result<Unit> {
        return withContext(Dispatchers.Default) {
            try {
                appDatabase.transaction {
                    appDatabase.answerSelectionTableQueries.deleteAnswerSelectionByAnswerIds(
                        answerIds
                    )
                }
                Result.Success(Unit)
            } catch (e: Exception) {
                Result.Error(e)
            }
        }
    }

    override suspend fun getAnswerSelectionByAnswerId(answerId: String): Result<AnswerSelectionModel> {
        return withContext(Dispatchers.Default) {
            try {
                val result = appDatabase.transactionWithResult {
                    appDatabase.answerSelectionTableQueries
                        .getAnswerSelectionByAnswerId(answerId)
                        .executeAsOne()
                        .toAnswerSelectionModel()
                }
                Result.Success(result)
            } catch (e: Exception) {
                Result.Error(e)
            }
        }
    }
}
